import { render, staticRenderFns } from "./TopItemsTable.vue?vue&type=template&id=0c944ae6&"
import script from "./TopItemsTable.vue?vue&type=script&lang=js&"
export * from "./TopItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./TopItemsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports